/** iPad 请求桌面网站时使用 Mac UA，仍须明确向服务端请求移动副本。 */
export function isMobileOperatingSystem(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
